var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"pa-2"},[_c('v-col',{attrs:{"sm":"12","md":"4","lg":"3","xl":"2"}},[_c('players-container',{attrs:{"players-item":_vm.playersItem},on:{"playerSelected":_vm.playerSelectedChanged}})],1),_c('v-col',{attrs:{"sm":"12","md":"8","lg":"9","xl":"10"}},[_c('GmapMap',{ref:"sharerMap",staticClass:"status-map",attrs:{"center":_vm.centerMap,"zoom":_vm.zoomMap,"map-type-id":"terrain","options":{
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: true,
        }},on:{"click":function($event){_vm.isInfoShown = false}}},_vm._l((_vm.playerList),function(marker,index){return _c('GmapMarker',{key:index,attrs:{"position":marker.position,"clickable":true,"draggable":false,"icon":{ url: _vm.url(marker.problems) },"title":marker.name},on:{"click":function($event){marker.isInfoShown = _vm.clickInfo(marker)}}},[_c('GmapInfoWindow',{attrs:{"opened":marker.isInfoShown,"options":{
              content:
                '<span class=\'iconTitle\'></span>' +
                '<span> </span>' +
                '<span class=\'icon\'>' +
                marker.name +
                '</span>' +
                '<br/><br/>' +
                '<span class=\'iconNetwork\'></span>' +
                '<span style=\'color:black\'> ' +
                _vm.$t('status.last-connection') +
                ' : ' +
                marker.lastConnection +
                '</span>' +
                '<br/><br/>' +
                '<span class=\'iconUpdate\'></span>' +
                '<span style=\'color:black\'> ' +
                _vm.$t('status.last-update') +
                ' : ' +
                marker.lastUpdate +
                '</span>',
            }},on:{"closeclick":function($event){marker.isInfoShown = false}}})],1)}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }